<template>
  <div class="page-template">
        <div class="page-title">{{ title }}</div>
        <div class="mall-title">
            <span>销售汇总数据</span>
            <div class="goods-data">
           <div class="goods-data-data" v-for="(v,i) in datalist" :key="i">
            <div :style="{color:v.color}">0</div>
            <span>{{ v.data }}</span>
          </div>
      </div>
        </div>
        <div class="mall-title">
            <span>订单交易量趋势图</span>
            <div class="order-trend">
                <search-form-template
                   :searchOptions="orderSearchOptions"
                ></search-form-template>
                <div class="echart-area">
                    <echarts-template class="charts-box" ref="orderTrendEcharts" 
                            :picOption="orderTrendEcharts">
                    </echarts-template>
                </div>
               
            </div>
        </div>
  </div>
</template>

<script>
import searchFormTemplate from '@/components/template/searchFormTemplate';
import echartsTemplate from "@/components/controls/echarts";
import {orderTrendEcharts} from '@/page/home/options/saleReportEcharts'

export default {
    components:{searchFormTemplate,echartsTemplate},
   created(){
       this.getOrderTend()
   },
   mounted(){
       this.title = document.title;
   },
   data(){
       return {
           orderTrendEcharts,
           title:"",
           datalist:[
              {data: "今日交易额（元）", color: "#5f58e6"},
              {data: "今日订单数（笔）", color: "#5f58e6"},
              {data: "今日新增用户数（个）", color: "#5f58e6"},
              {data: "月活跃用户数（个）", color: "#5f58e6"},
           ],
           orderSearchOptions:{
               simple: [
            {
              label: '',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              rangeButton:[{label:'近7天',value:3},{label:'本月',value:6},{label:'上月',value:7}],
              span: 24
            },
                ]
           },
       }
   },
   methods:{
       getOrderTend() {
      this.$nextTick(() => {
        this.$refs.orderTrendEcharts.drawpic();
      });
   }
   }
}
</script>

<style scoped>
.mall-title>span{
   font-weight: bold;
}
.mall-title>span::before{
    content:"";
    display: inline-block;
    width:9px;
    height:9px;
    border-radius: 50%;
    background: #5f58e6;
    margin-right: 5px;
}
.goods-data{
    height: 100px;
    display: flex;
    width:100%;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: 10px;
}
.goods-data .goods-data-data{
    background: #fff;
    width:24%;
    border-radius: 14px;
    padding: 15px;
    box-shadow: 3px 3px 3px #e1e1e1;
    height: 111px;
}
.goods-data .goods-data-data>div{
    font-size: 28px;
    margin-bottom: 10px;
}
.mall-title .order-trend{
    width: 50%;
    height: 430px;
    margin-top: 10px;
    border-radius: 8px;
    box-shadow: 3px 3px 3px #e1e1e1;
    background: #fff;
    padding: 20px;
}
.echart-area{
    height: 85%;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/page/report/sales/Mall.vue